<template>
    <div id="app-footer-pre" class="grey white--text">
        <v-layout id="app-footer-post">
            <v-col class="black white--text">
                <v-row class="justify-center">
                    {{ $t('footer.addressFooter') }}   |   {{ $t('footer.phoneFooter') }}   |   {{ $t('footer.emailFooter') }}
                </v-row>
                <v-row class="justify-center">
                    {{ $t('footer.copyrightFooter') }}
                </v-row>
            </v-col>
        </v-layout>
    </div>

</template>

<script>
export default {
  name: 'ContactMessageUs',

  data: () => ({
  }),
};
</script>

<style scoped>
#app-footer-pre {
  /* margin-top: 80px; */
}
.footer-links {
    color: #FFFFFF;
    text-decoration: none;
}
</style>
